import { Component, OnInit, HostListener, AfterViewInit } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { UserSettingsService } from '../user-settings.service';
import { Router } from '@angular/router';
import { ResidentialService } from '../../questionarie-signup/questionnaire-residential/residential.service';
import * as _ from 'underscore';
import { filter } from 'rxjs/operators';
import { LocationStrategy } from '@angular/common';

@Component({
  selector: 'app-user-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent implements OnInit, AfterViewInit {
  url = environment.api_url;
  notification_List;
  notify_count = 0;
  userObj = {
    accountId: '',
  };
  userDataObj;
  name;
  seeArchieveShow = false;
  shoeProgress;
  notifi_Count = 0;
  deviceWidth;
  notifiDrop;
  notifyMob;
  read_id;
  seeArch;
  bodyClassAdd;
  hg_accountId;
  hideNotifi;
  id_Name;
  screenSize;
  indexValue = 0;
  hideNotify;
  CompletedEnable = false;
  // showSeearchive = true;
  queryObj = {
    _id: '',
    hg_accountId: '',
    esiid: '',
    hg_orders_id: '',
  };
  updateObj = {
    isRead: false,
  };
  isChecked;
  // totalDivHeight = 0;
  totalDivHeight;
  firstDivHeight = 0;
  first_height;
  showNotificationPanel;

  constructor(
    private http: HttpClient,
    private userSettingsService: UserSettingsService,
    private router: Router,
    private residentialService: ResidentialService,
    private location: LocationStrategy
  ) {
    const self = this;
    this.deviceWidth = window.innerWidth;
  
  }

  closeNav() {
    // const elemntObjt = document.getElementById('hideprocess');
    // const hidetext = document.getElementById('hidetxt');
    // if (elemntObjt !== null && elemntObjt.classList.contains('buttonhide')) {
    //   elemntObjt.classList.remove('buttonhide');
    // }
    // if (hidetext !== null && hidetext.classList.contains('buttonhide')) {
    //   hidetext.classList.remove('buttonhide');
    // }
    // const collapse = document.getElementById('mySidebar');
    // collapse.classList.remove('sidemenu');
    // document.getElementById('mySidebar').style.width = '0';
    // //document.getElementById('main').style.marginLeft = '0';
  }

  getSelectedEventClassList(event) {
    return window.location.href.indexOf('congrats') !== -1;
  }

  redirctCurrent(){

    this.router.navigate([
            'user-settings',
            JSON.parse(sessionStorage.getItem('userObj'))._id,
          ]);
  }

  openNav(event) {

      //const elemntObjt = document.getElementById('hideprocess');
      const hidetext = document.getElementById('hidetxt');
      //elemntObjt.classList.add('buttonhide');
      hidetext.classList.add('buttonhide');
      const collapse = document.getElementById('mySidebar');
      collapse.classList.add('sidemenu');
      document.getElementById('mySidebar').style.width = '250px';
      //document.getElementById('main').style.marginLeft = '250px';
      const elementObj = document.getElementById('menuIcon');
      if(!$("#navbarsExampleDefault").hasClass('show'))
      {
        $("#navbarsExampleDefault").addClass('show')
        $(".navbar").addClass('parent_')
        elementObj.classList.remove('closeicn');
            elementObj.classList.add('listicn');
            elementObj['src'] = 'assets/images/close.svg';
      }else
      {
        $("#navbarsExampleDefault").removeClass('show')
        $(".navbar").removeClass('parent_')
            elementObj.classList.remove('listicn');
      elementObj.classList.add('closeicn');
      elementObj['src'] = 'assets/images/list.png';
      }
    
  }
  ngOnInit() {

    window.addEventListener('mouseup', function (event) {
      const hidetext = document.getElementById('hideprocess');
      if (
        hidetext &&
        hidetext.className &&
        hidetext.className !== 'navbar-brand logomain mt-2'
      ) {
        self.closeNav();
      }
    });

    // MenuBar closed : When menubar open, scroll the page.
    window.onscroll = function () {
      const hidetxtScroll = document.getElementById('hideprocess');
      if (
        hidetxtScroll !== null &&
        hidetxtScroll.className &&
        hidetxtScroll.className !== 'navbar-brand logomain mt-2'
      ) {
        self.closeNav();
      }
    };



    const user = sessionStorage.getItem('userObj');
    if (user) {
    //  const body = new HttpParams();
      let questionnarieObj = sessionStorage.getItem('userResponse');
      let percentage = sessionStorage.getItem('percentage');
      if (questionnarieObj && user) {
        // body.append('questionnarieObj', questionnarieObj);
        // body.append('userObj', user);
        // body.append('percentage', percentage);

        const body = new HttpParams()
        .append('questionnarieObj', questionnarieObj)
        .append('userObj', user)
        .append('percentage', percentage);

        // this.http
        //   .post(this.url + '/saveQuestions', body)
        //   .subscribe((res: any) => {
        //     console.log(res);
        //   });
      }
    }
    this.userSettingsService.getUserObj.subscribe((data) => {
      if (data['userObj']) {
        this.userDataObj = data['userObj'].user;
        this.name = this.userDataObj.fName + ' ' + this.userDataObj.lName;
      }
    });
    this.userObj.accountId = this.userSettingsService.hg_accountId;
    const self = this;
    this.userSettingsService.setShowNotifyPanel.subscribe((data) => {
      // console.log.log(data.flag);
      this.showNotificationPanel = data.flag;
      if (this.showNotificationPanel === true) {
        const mouseEvent = document.getElementById('notifificatn');
        mouseEvent.classList.add('notifishow');
        this.notificationclick();
      }
    });
    // Get All notifications:
    this.hg_accountId = window.location.href.split('/').pop();
    const body = new HttpParams().append('hg_accountId', this.hg_accountId);
    this.http
      .get(this.url + '/getNotification', { params: body })
      .subscribe((res: any) => {
        this.notification_List = res;
        if (
          this.notification_List &&
          this.notification_List.statusCode &&
          this.notification_List.statusCode === '0010'
        ) {
          this.router.navigateByUrl('/login');
        } else {
          this.notification_List.map((row, i) => {
            if (!row.isRead) {
              this.notify_count += 1;
            }
          });
        }
      });

    // height of the div height
    const heightheader = <HTMLInputElement>(
      document.getElementById('headerHeight')
    );
    const valueHeader = heightheader.offsetHeight;

    const visitor = screen.height;
    this.screenSize = visitor - valueHeader + 200;
  }

  ngAfterViewInit(): void {
    this.bodyClassAdd = document.getElementsByTagName('body');
    this.bodyClassAdd[0].classList.remove('bodyTag');
  }

  // Notification closed : When notification open, click the anywhere on the page.
  //@HostListener('document:mouseup', ['$event'])
  // addClass($event) {
  //   const elementObj = document.getElementById('menuIcon');
  //   const navElement = document.getElementById('navbarsExampleDefault');
  //   if (navElement.classList.contains('show')) {
  //     elementObj.classList.remove('listicn');
  //     elementObj.classList.add('closeicn');
  //     elementObj['src'] = 'assets/images/list.png';
  //   } else {
  //     elementObj.classList.remove('closeicn');
  //     elementObj.classList.add('listicn');
  //     elementObj['src'] = 'assets/images/close.svg';
  //   }
  // }

  notificationclick() {
    // body class add
    this.bodyClassAdd = document.getElementsByTagName('body');
    this.bodyClassAdd[0].classList.add('bodyTag');

    this.totalDivHeight = 0;
    this.seeArch = 0;
    let indexx = 0;
    if (this.notification_List.length > 0) {
      this.userSettingsService.setNotifyFlag({
        flag: true,
        notifyType: 'hideallnotify',
      });
      for (let i = 0; i < this.notification_List.length; i++) {
        const id_tab = 'firstValueHeight' + i;
        const headerheightt = <HTMLElement>document.getElementById(id_tab);
        this.firstDivHeight =
          headerheightt.offsetHeight !== 0
            ? headerheightt.offsetHeight
            : Number(headerheightt.offsetTop) - Number(8);
        if (this.firstDivHeight !== 0) {
          this.totalDivHeight = this.totalDivHeight + this.firstDivHeight;
          if (this.totalDivHeight <= this.screenSize) {
            indexx++;
            this.indexValue = indexx - 1;
            this.seeArch = this.indexValue + 1;
          }
        }
      }
      this.setNotificationContainer('bold');
    }
    setTimeout(() => {
      for (let m = 0; m < this.notification_List.length; m++) {
        this.id_Name = 'notify' + m;
        const textWeightInit = document.getElementById(this.id_Name);
        const notification = this.notification_List[m];
        if (
          notification.isRead === false &&
          textWeightInit !== null &&
          this.updateObj &&
          this.updateObj.isRead === false
        ) {
          textWeightInit.classList.add('semi-bold');
        }
      }
    }, 50);

    if (this.deviceWidth < 768) {
      document.getElementById('notifificatn').classList.add('dipy');
      const mobvalueNotify = document.getElementsByTagName('html');
      mobvalueNotify[0].classList.add('mbNotify');
      const mobilenotifyy = document.getElementById('WholeNotify');
      mobilenotifyy.classList.add('mbbNitify');
    }
  }
  setNotificationContainer(fontStyle) {
    this.hideNotifi = document.getElementById('notifificatn');
    const height = `${this.totalDivHeight}px !important`;
    document.getElementById('notifificatn').style.height = '174px';
    document.getElementById('notifificatn').style.width = '350px';
    this.hideNotifi.classList.add('notifishow');
    const styleRead = document.getElementById('listName');
    // document.getElementById('listName').style.fontWeight = fontStyle;
    document.getElementById('listName').style.fontSize = '18px';
  }

  readNotify(event, selectedNotification, id) {
    // setTimeout(() => {
    console.log('Event' + event);
    console.log('SelectedNotification' + selectedNotification);
    this.isChecked = event.target.checked;
    this.queryObj.hg_accountId = selectedNotification.hg_accountId;
    this.queryObj._id = selectedNotification._id;
    this.queryObj.esiid = selectedNotification.esiid;
    this.queryObj.hg_orders_id = selectedNotification.hg_orders_id;
    if (selectedNotification.isRead === false) {
      this.notification_List.isRead = true;
      this.updateObj.isRead = true;
      if (this.notify_count !== 0) {
        this.notify_count = this.notify_count - 1;
      }
    }
    const updateNotify = new HttpParams()
      .append('queryObj', JSON.stringify(this.queryObj))
      .append('updateObj', JSON.stringify(this.updateObj));
    this.http
      .post(this.url + '/updateNotification', updateNotify)
      .subscribe((res: any) => {
        const notifyRes = res;
        this.read_id = 'notify' + id;
        const textWeight = document.getElementById(this.read_id);
        document
          .getElementById(this.read_id)
          .classList.remove('font-weight-bold-calibre');
        document
          .getElementById(this.read_id)
          .classList.add('font-weight-normal-calibre');
      });
  }

  // See Archieve click function.
  seeArchieve() {
    this.shoeProgress = document.getElementById('seeArchieveShoww');
    if (this.seeArchieveShow === true) {
      this.seeArchieveShow = false;
      if (this.shoeProgress.classList.contains('viewToggle')) {
        this.shoeProgress.classList.remove('viewToggle');
      }
    } else {
      this.seeArchieveShow = true;
      this.shoeProgress.classList.add('viewToggle');
    }
    setTimeout(() => {
      for (let m = 0; m < this.notification_List.length; m++) {
        this.id_Name = 'notify' + m;
        const textWeightInit = document.getElementById(this.id_Name);
        const notification = this.notification_List[m];
        if (notification.isRead === false && textWeightInit !== null) {
          textWeightInit.classList.add('semi-bold');
        }
      }
    }, 50);
  }

  faqus() {
    sessionStorage.setItem('faqFlag', 'faq');
    sessionStorage.removeItem('contcusFlag');
  }

  fcontactus() {
    sessionStorage.setItem('contcusFlag', 'contact');
    sessionStorage.removeItem('faqFlag');
  }

  notiClose() {
    const notifiCloseBtn = document.getElementById('notifificatn');
    notifiCloseBtn.classList.remove('notifishow');

    if (this.deviceWidth < 768) {
      document.getElementById('notifificatn').classList.remove('dipy');
      const mobilenotifyyClose = document.getElementById('WholeNotify');
      if (mobilenotifyyClose !== null) {
        mobilenotifyyClose.classList.remove('mbbNitify');
      }
    }
    // Mobile notify
    const mobvalueNotifyRemove = document.getElementsByTagName('html');
    if (mobvalueNotifyRemove !== null) {
      mobvalueNotifyRemove[0].classList.remove('mbNotify');
    }
  }
  logout() {
    const logoutParams = new HttpParams().append(
      'userObj',
      sessionStorage.getItem('userObj')
    );
    this.http
      .get(this.url + '/logout', { params: logoutParams })
      .subscribe((res: any) => {
        // To remove the existing user response
        localStorage.clear();
        sessionStorage.clear();
        if(this.residentialService.userResponse != null)
        {

          this.residentialService.userResponse.userResponses = [];
        }
        const logoutRes = res;
     
        if(this.router.url != null  && this.router.url.indexOf("user-settings") > -1)
        {
          this.router.navigate(['/login'], {
           
          });
        }
        else
        {
          this.router.navigate(['/login'], {
            queryParams: { returnUrl: this.router.url },
          });
        }

      });
  }
  redirectToHome() {
    this.router.navigateByUrl('/');
  }

  //Button click actions.
  completeProcessnew() {
    let notifyObj: any = JSON.parse(
      sessionStorage.getItem('notifyiterationList')
    );
    notifyObj = notifyObj[0];
    this.residentialService.isStartOver = false;
    if (notifyObj.type === 'questionnarie_not_completed') {
      this.userSettingsService.questionNotificationObj = notifyObj;
    } else if (
      notifyObj.type === 'enrollment_not_completed' ||
      notifyObj.type === 'renewal'
    ) {
      this.userSettingsService.enrollNotificationObj = notifyObj;
    }
    // getting the username to save in localstorage for add another address flow.
    const userName = localStorage.getItem('userName');

    // To remove the existing user response for renewal type
    this.residentialService.questionFlowType = notifyObj.type;
    localStorage.setItem('userName', userName);

    if (notifyObj.type === 'renewal' || notifyObj.type === 'add-address') {
      this.residentialService.messageService({});
      this.residentialService.userResponse.userResponses = [];
      // for renewal
      if (notifyObj.type === 'renewal') {
        // clear existing userresponse
        sessionStorage.clear();
        this.residentialService.messageService({});
        this.residentialService.userResponse.userResponses = [];
      }

      const body = new HttpParams()
        .append('hg_accountId', notifyObj.hg_accountId)
        .append('esiid', notifyObj.esiid)
        .append('userAddress', notifyObj.userAddress);
      // get the questionnarie response
      this.http
        .get(this.url + '/residentialRes', { params: body })
        .subscribe((res: any) => {
          const questionarieRes = res;
          if (!_.isEmpty(questionarieRes)) {
            sessionStorage.setItem('questionId', questionarieRes._id);
            sessionStorage.setItem('formateAddress', notifyObj.userAddress);
            this.residentialService.userResponse.userResponses.push(
              questionarieRes['res_user_responses'][0]
            );
            this.residentialService.serviceResObj = _.findWhere(
              questionarieRes['res_user_responses'],
              { res_question_id: '002' }
            );
            this.residentialService.userResponse.userResponses.push(
              _.findWhere(questionarieRes['res_user_responses'], {
                res_question_id: '008',
              })
            );
            this.router.navigate([notifyObj.buttonUrl]);
          }
        });
    } else {
      const searchObj = new HttpParams()
        .append('hg_accountId', notifyObj.hg_accountId)
        .append('esiid', notifyObj.esiid)
        .append('userAddress', notifyObj.userAddress);
      this.http
        .get(this.url + '/residentialRes', { params: searchObj })
        .subscribe((res: any) => {
          const questionarieRes = res;
          if (
            !_.isEmpty(questionarieRes) &&
            questionarieRes['res_user_responses'].length == 0 &&
            notifyObj.type === 'enrollment_not_completed'
          ) {
            const lastArr = _.last(questionarieRes['res_user_responses']);
            this.residentialService.messageService({
              currentId: '000',
            });
            const questionObj =
              '{"questionStatus":"Quitted","questionStep":"001","type":"","property":"","percentage":null}';
            sessionStorage.setItem('questionStatusObj', questionObj);
            this.router.navigateByUrl('/residentialQues');
          }

          if (
            !_.isEmpty(questionarieRes) &&
            questionarieRes['res_user_responses'].length !== 0 &&
            notifyObj.type === 'enrollment_not_completed' && questionarieRes['res_user_responses'].length >= 17
          ) {
            this.residentialService.userResponse.userResponses =
              questionarieRes.res_user_responses;

            var localquestions =  JSON.parse(sessionStorage.getItem(
              'userResponse'
            ));

         

             if(localquestions['userResponses'].length >= 17)
             {

              sessionStorage.setItem(
                'userResponse',
                JSON.stringify(this.residentialService.userResponse)
              );

              this.router.navigate(['pre-success']);
             }else
             {

              const lastArr = localquestions['userResponses'][localquestions['userResponses'].length - 2].res_question_id;
              this.residentialService.messageService({
                currentId: lastArr,
              });
              this.router.navigateByUrl('/residentialQues');
             }




          
          }else
          {

            if (
              !_.isEmpty(questionarieRes) &&
              questionarieRes['res_user_responses'].length > 0
            ) {



              const lastArr = _.last(questionarieRes['res_user_responses']);
              this.residentialService.messageService({
                currentId: lastArr.res_question_id,
              });
              this.router.navigateByUrl('/residentialQues');
              // some cases not getting the userResponse from session
              // if (notifyObj.type === 'enrollment_not_completed') {
              //   this.residentialService.userResponse.userResponses =
              //     questionarieRes.res_user_responses;
              //   sessionStorage.setItem(
              //     'userResponse',
              //     JSON.stringify(this.residentialService.userResponse)
              //   );
              //   this.router.navigate(['pre-success']);
              // } else {
              //   sessionStorage.setItem('questionId', questionarieRes._id);
              //   sessionStorage.setItem('formateAddress', notifyObj.userAddress);
              //   this.residentialService.userResponse.userResponses.push(
              //     questionarieRes['res_user_responses'][0]
              //   );
              //   this.residentialService.serviceResObj = _.findWhere(
              //     questionarieRes['res_user_responses'],
              //     { res_question_id: '002' }
              //   );
              //   this.residentialService.userResponse.userResponses.push(
              //     _.findWhere(questionarieRes['res_user_responses'], {
              //       res_question_id: '008',
              //     })
              //   );
              //   const houseHold = _.findWhere(
              //     questionarieRes['res_user_responses'],
              //     { res_question_id: '0014' }
              //   );
              //   if (!_.isEmpty(houseHold)) {
              //     this.residentialService.childrens =
              //       houseHold.fieldValue.children;
              //     this.residentialService.adults = houseHold.fieldValue.adults;
              //   }
              //   this.router.navigate([notifyObj.buttonUrl]);
              // }
            }

          }

         
          if (questionarieRes == null) {
            this.residentialService.messageService({
              currentId: '000',
            });
            const questionObj =
              '{"questionStatus":"Quitted","questionStep":"000","type":"","property":"","percentage":null}';
            sessionStorage.setItem('questionStatusObj', questionObj);
            this.router.navigateByUrl('/residentialQues');
          }
        });
    }
  }


  completeProcess() {
    let notifyObj: any = JSON.parse(
      sessionStorage.getItem('notifyiterationList')
    );
    notifyObj = notifyObj[0];
    this.residentialService.isStartOver = false;
    if (notifyObj.type === 'questionnarie_not_completed') {
      this.userSettingsService.questionNotificationObj = notifyObj;
    } else if (
      notifyObj.type === 'enrollment_not_completed' ||
      notifyObj.type === 'renewal'
    ) {
      this.userSettingsService.enrollNotificationObj = notifyObj;
    }
    // getting the username to save in localstorage for add another address flow.
    const userName = localStorage.getItem('userName');

    // To remove the existing user response for renewal type
    this.residentialService.questionFlowType = notifyObj.type;
    localStorage.setItem('userName', userName);

    if (notifyObj.type === 'renewal' || notifyObj.type === 'add-address') {
      this.residentialService.messageService({});
      this.residentialService.userResponse.userResponses = [];
      // for renewal
      if (notifyObj.type === 'renewal') {
        // clear existing userresponse
        sessionStorage.clear();
        this.residentialService.messageService({});
        this.residentialService.userResponse.userResponses = [];
      }

      const body = new HttpParams()
        .append('hg_accountId', notifyObj.hg_accountId)
        .append('esiid', notifyObj.esiid)
        .append('userAddress', notifyObj.userAddress);
      // get the questionnarie response
      this.http
        .get(this.url + '/residentialRes', { params: body })
        .subscribe((res: any) => {
          const questionarieRes = res;
          if (!_.isEmpty(questionarieRes)) {
            sessionStorage.setItem('questionId', questionarieRes._id);
            sessionStorage.setItem('formateAddress', notifyObj.userAddress);
            this.residentialService.userResponse.userResponses.push(
              questionarieRes['res_user_responses'][0]
            );
            this.residentialService.serviceResObj = _.findWhere(
              questionarieRes['res_user_responses'],
              { res_question_id: '002' }
            );
            this.residentialService.userResponse.userResponses.push(
              _.findWhere(questionarieRes['res_user_responses'], {
                res_question_id: '008',
              })
            );
            this.router.navigate([notifyObj.buttonUrl]);
          }
        });
    } else {
      const searchObj = new HttpParams()
        .append('hg_accountId', notifyObj.hg_accountId)
        .append('esiid', notifyObj.esiid)
        .append('userAddress', notifyObj.userAddress);
      this.http
        .get(this.url + '/residentialRes', { params: searchObj })
        .subscribe((res: any) => {
          const questionarieRes = res;
          if (
            !_.isEmpty(questionarieRes) &&
            questionarieRes['res_user_responses'].length == 0 &&
            notifyObj.type === 'enrollment_not_completed'
          ) {
            const lastArr = _.last(questionarieRes['res_user_responses']);
            this.residentialService.messageService({
              currentId: '000',
            });
            const questionObj =
              '{"questionStatus":"Quitted","questionStep":"001","type":"","property":"","percentage":null}';
            sessionStorage.setItem('questionStatusObj', questionObj);
            this.router.navigateByUrl('/residentialQues');
          }

          if (
            !_.isEmpty(questionarieRes) &&
            questionarieRes['res_user_responses'].length !== 0 &&
            notifyObj.type === 'enrollment_not_completed' && questionarieRes['res_user_responses'].length >= 17
          ) {
            this.residentialService.userResponse.userResponses =
              questionarieRes.res_user_responses;
           

            var IsHaveEnrollPlans = sessionStorage.getItem(
              'IsHaveEnrollPlans',
             
            );

            if(IsHaveEnrollPlans == "true")
            {
              var localquestions =  JSON.parse(sessionStorage.getItem(
                'userResponse'
              ));
  
           
  
               if(localquestions != null && localquestions['userResponses'].length != 0)
               {
  
                  sessionStorage.setItem(
                    'userResponse',
                    JSON.stringify(localquestions)
                  );

                  if(localquestions['userResponses'].length >= 17)
                  {
                    var goto_success = true; 
                    const checkservice = _.findWhere(localquestions['userResponses'], {
                      res_question_id: '002',
                    });
            
                    if(checkservice != undefined && checkservice != null &&  checkservice.fieldValue == 'New Service'   )
                    {
                      const terms = _.findWhere(localquestions['userResponses'], {
                        res_question_id: '0026',
                      });
              
                      if(terms != undefined && terms != null && ( terms.fieldValue != '' || terms.fieldValue != null )  )
                      {
              
                 
                      }else
                      {
                        goto_success = false;
                      }
                    }else
                    {
                      const usagehistory = _.findWhere(localquestions['userResponses'], {
                        res_question_id: '0030',
                      });

                      if(usagehistory != undefined && usagehistory != null  )
                      {
                        goto_success = true;
                      }else
                      {
                        goto_success = false;
                      }

                    


                    }

                    if(goto_success)
                    {
                      this.router.navigate(['pre-success']);
                      
                    }else
                    {
                      const lastArr = _.last(localquestions['userResponses']);
                      this.residentialService.messageService({
                        currentId: lastArr.res_question_id,
                      });
                      this.router.navigateByUrl('/residentialQues');

                    }


                  

                  }else
                  {
                    const lastArr = _.last(localquestions['userResponses']);
                    this.residentialService.messageService({
                      currentId: lastArr.res_question_id,
                    });
                    this.router.navigateByUrl('/residentialQues');

                  }

  
              
               }
               else
               {   
                // sessionStorage.setItem(
                //   'userResponse',
                //   JSON.stringify('{res_question_id: "001", fieldName: "first_name", fieldValue: ""}')

                // );

                this.residentialService.messageService({
                  currentId: '000',
                });
                const questionObj =
                  '{"questionStatus":"Quitted","questionStep":"000","type":"","property":"","percentage":null}';
                sessionStorage.setItem('questionStatusObj', questionObj);

              

                this.router.navigateByUrl('/residentialQues');
               }

            }else
            {

              sessionStorage.setItem(
                'userResponse',
                JSON.stringify(this.residentialService.userResponse)
              );

              this.router.navigate(['pre-success']);
            }

         

          
          }else
          {
          if (
            !_.isEmpty(questionarieRes) &&
            questionarieRes['res_user_responses'].length > 0
          ) {

            // sessionStorage.setItem(
            //   'userResponse',
            //   JSON.stringify(this.residentialService.userResponse)
            // );
            var IsHaveEnrollPlans = sessionStorage.getItem(
              'IsHaveEnrollPlans',
             
            );

            if(IsHaveEnrollPlans == "true")
            {
              this.residentialService.messageService({
                currentId: '000',
              });
              const questionObj =
                '{"questionStatus":"Quitted","questionStep":"000","type":"","property":"","percentage":null}';
              sessionStorage.setItem('questionStatusObj', questionObj);

            

              this.router.navigateByUrl('/residentialQues');

            }else
            {

              const lastArr = _.last(questionarieRes['res_user_responses']);
              this.residentialService.messageService({
                currentId: lastArr.res_question_id,
              });
              this.router.navigateByUrl('/residentialQues');
            }


            // some cases not getting the userResponse from session
            // if (notifyObj.type === 'enrollment_not_completed') {
            //   this.residentialService.userResponse.userResponses =
            //     questionarieRes.res_user_responses;
            //   sessionStorage.setItem(
            //     'userResponse',
            //     JSON.stringify(this.residentialService.userResponse)
            //   );
            //   this.router.navigate(['pre-success']);
            // } else {
            //   sessionStorage.setItem('questionId', questionarieRes._id);
            //   sessionStorage.setItem('formateAddress', notifyObj.userAddress);
            //   this.residentialService.userResponse.userResponses.push(
            //     questionarieRes['res_user_responses'][0]
            //   );
            //   this.residentialService.serviceResObj = _.findWhere(
            //     questionarieRes['res_user_responses'],
            //     { res_question_id: '002' }
            //   );
            //   this.residentialService.userResponse.userResponses.push(
            //     _.findWhere(questionarieRes['res_user_responses'], {
            //       res_question_id: '008',
            //     })
            //   );
            //   const houseHold = _.findWhere(
            //     questionarieRes['res_user_responses'],
            //     { res_question_id: '0014' }
            //   );
            //   if (!_.isEmpty(houseHold)) {
            //     this.residentialService.childrens =
            //       houseHold.fieldValue.children;
            //     this.residentialService.adults = houseHold.fieldValue.adults;
            //   }
            //   this.router.navigate([notifyObj.buttonUrl]);
            // }
          }
         }
          if (questionarieRes == null) {
            this.residentialService.messageService({
              currentId: '000',
            });
            const questionObj =
              '{"questionStatus":"Quitted","questionStep":"000","type":"","property":"","percentage":null}';
            sessionStorage.setItem('questionStatusObj', questionObj);
            this.router.navigateByUrl('/residentialQues');
          }
        });
    }
  }
}
